import * as React from 'react';
import { toNumberPrecision } from '../../utils/formatNumber/toNumberPrecision';
import * as style from './styles.css';

interface IInterestRateItemProps {
  imageSrc: string;
  rate: number;
  rateFor: string;
}

export const InterestRateItem: React.FC<IInterestRateItemProps> = ({ rate, imageSrc, rateFor }) => {
  return (
    <div className={style['card']}>
      <img className={style['img']} src={imageSrc} alt="" />
      <div className={style['text']}>
        <span className={style['rate']}>{toNumberPrecision(rate * 100, 2)}%</span> на {rateFor}
      </div>
    </div>
  );
};
